import React from 'react'

export const AChatUserInitials = ({ initials }) => (
  <div className="relative flex justify-center items-center flex-shrink-0 w-7 h-7 text-gray-900 bg-gray-50 rounded-full overflow-hidden transform-gpu">
    <p className="text-xs">{initials}</p>
  </div>
)
